import { render } from "./wfm-list-items.vue?vue&type=template&id=ffe31b2a&scoped=true"
import script from "./wfm-list-items.vue?vue&type=script&lang=js"
export * from "./wfm-list-items.vue?vue&type=script&lang=js"

import "./wfm-list-items.vue?vue&type=style&index=0&id=ffe31b2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe31b2a"]])

export default __exports__